import BankDetailsModel from "./bank-details.model";
import BaseModel from "./base.model";
export default class PaymentDetailsModel extends BaseModel {

  payment_options = [
    {
      label: "Credit Card",
      value: "credit_card"
    },
    {
      label: "Debit Order",
      value: "debit_order"
    }
  ];
  payment_option_type = 'credit_card';
  bank_details = new BankDetailsModel();

  constructor (data) {    
    super();
    if(this.isEmpty(data)) return this;
    this.payment_options = data.payment_options;
    this.payment_option_type = data.payment_option_type;
    this.bank_details = new BankDetailsModel(data.bank_details);
  }

  validatePaymentDetails() {
    var self = this;
    if(self.payment_option_type == "debit_order") {
      return self.bank_details.validateBankDetails();
    }
    return true;
  }
  
}